export default "__VITE_ASSET__Ckm3iFKl__"